/**
 *
 * Campaigns/Campaign/Form/CallCenterScripts
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import { BlockedMessage } from 'components/Organizations/Index'
import { titleize } from '@joeyparis/utils'

// Components

function CampaignFormCallCenterScripts({ campaign_state, organization, handleInputChange, current_user, disabled }) {
	const {
		default_phone_closing: org_phone_closing,
		default_phone_greeting: org_phone_greeting,
		operator_notes: org_operator_notes,
		waitlist_phone_closing: org_waitlist_phone_closing,
	} = organization || {}

	const disabled_fields = {
		phone_greeting: !!org_phone_greeting && org_phone_greeting !== '',
		phone_closing: !!org_phone_closing && org_phone_closing !== '',
		operator_notes: !!org_operator_notes && org_operator_notes !== '',
		waitlist_phone_closing: !!org_waitlist_phone_closing && org_waitlist_phone_closing !== '',
	}

	const disabled_fields_titles = Object.entries(disabled_fields)
		.filter(([, value]) => value)
		.map(([key]) => titleize(key))

	return (
		<div className="row">
			{disabled_fields_titles.length > 0 && (
				<BlockedMessage
					category={disabled_fields_titles}
					organization_name={organization?.name}
					className="mx-2"
				/>
			)}

			<div className="form-group col-lg-6">
				<label className="form-text text-muted" htmlFor="phone_greeting">
					Phone Greeting
				</label>
				<textarea
					rows={3}
					className="form-control"
					name="phone_greeting"
					value={organization?.default_phone_greeting || campaign_state.phone_greeting}
					onChange={handleInputChange}
					disabled={!current_user.is_consultant || disabled_fields.phone_greeting || disabled}
				/>
			</div>
			<div className="form-group col-lg-6">
				<label className="form-text text-muted" htmlFor="phone_closing">
					Phone Closing
				</label>
				<textarea
					rows={3}
					className="form-control"
					name="phone_closing"
					value={organization?.default_phone_closing || campaign_state.phone_closing}
					onChange={handleInputChange}
					disabled={!current_user.is_consultant || disabled_fields.phone_closing || disabled}
				/>
			</div>
			<div className="form-group col-lg-6">
				<label className="form-text text-muted" htmlFor="operator_notes">
					Operator Notes
				</label>
				<textarea
					rows={3}
					className="form-control"
					name="operator_notes"
					value={organization?.operator_notes || campaign_state.operator_notes || ''}
					onChange={handleInputChange}
					disabled={!current_user.is_consultant || disabled_fields.operator_notes || disabled}
				/>
			</div>
			{campaign_state.objective_index === 0 && (
				<div className="form-group col-lg-6">
					<label className="form-text text-muted" htmlFor="waitlist_phone_closing">
						Waitlist Phone Closing
					</label>
					<textarea
						rows={3}
						className="form-control"
						name="waitlist_phone_closing"
						value={organization?.waitlist_phone_closing || campaign_state.waitlist_phone_closing}
						onChange={handleInputChange}
						disabled={!current_user.is_consultant || disabled_fields.waitlist_phone_closing || disabled}
					/>
				</div>
			)}
		</div>
	)
}

CampaignFormCallCenterScripts.propTypes = {
	campaign_state: PropTypes.object,
	organization: PropTypes.object,
	current_user: PropTypes.object,
	handleInputChange: PropTypes.func,
	disabled: PropTypes.bool,
}

export default CampaignFormCallCenterScripts
